import React from "react";

function SearchIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.5 9.16667C3.5 6.03705 6.03705 3.5 9.16667 3.5C12.2963 3.5 14.8333 6.03705 14.8333 9.16667C14.8333 10.689 14.2331 12.0711 13.2563 13.0892C13.2256 13.1134 13.1961 13.1396 13.1678 13.1679C13.1395 13.1962 13.1133 13.2257 13.0891 13.2564C12.071 14.2331 10.6889 14.8333 9.16667 14.8333C6.03705 14.8333 3.5 12.2963 3.5 9.16667ZM13.8346 15.2489C12.5418 16.2426 10.9232 16.8333 9.16667 16.8333C4.93248 16.8333 1.5 13.4008 1.5 9.16667C1.5 4.93248 4.93248 1.5 9.16667 1.5C13.4008 1.5 16.8333 4.93248 16.8333 9.16667C16.8333 10.9233 16.2426 12.5419 15.2489 13.8347L18.207 16.7929C18.5976 17.1834 18.5976 17.8166 18.207 18.2071C17.8165 18.5976 17.1833 18.5976 16.7928 18.2071L13.8346 15.2489Z"
        fill="#2D3648"
      />
    </svg>
  );
}

export default SearchIcon;
